import { useLocation, useNavigate } from "react-router-dom";
import ContactForm from "./ContactForm";
import { Card, IconButton } from "components/common";
import { FaArrowLeft } from "react-icons/fa";
import React from 'react';

const EditContact = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {customer, contact} = location.state;

  const handleCancel = () => {
    navigate(-1);
    return null;
  }

  return (
    <Card padding="lg" className="tw-text-sm">
      <div className="tw-flex tw-justify-between tw-items-center tw-border-b tw-border-solid tw-border-slate-200 tw-pb-3">
        <h5 className="tw-mb-0 tw-font-semibold">Edit Contact</h5>
        <IconButton
          onClick={() => navigate(-1)}
          variant="secondary"
          size="sm"
          icon={<FaArrowLeft size={12} />}
        />
      </div>
      <div className="tw-mt-3">
        <ContactForm
          customer={customer}
          contact={contact}
          handleCancel={handleCancel}
        />
      </div>
    </Card>
  )
}

export default EditContact
